'use client';

import { getSelectItemData } from '../itemSelectionUtils';
import { productListItemToGAItem } from '../productMappers/productListItemToGAItem';
import { sendGTMEvent } from '../sendGTMEvent';
import { CommerceModel } from 'api-types';
import { NshiftType } from '~/components/modules/M160Checkout/components/DeliveryOptions/DeliveryOptions';

/**
 * Tracks when a user adds shipping information during checkout.
 * 
 * This function sends an add_shipping_info event with the cart contents
 * and shipping method information.
 * 
 * @param products - Array of line items in the cart
 * @param value - Total value of the cart
 * @param shippingTier - Shipping method/tier (e.g., 'GLS', 'Express')
 * @param currency - Currency code (optional, defaults to product currency or DKK)
 */
export const trackAddShippingInfo = (
  option: NshiftType,
  basket?: CommerceModel.Basket | null
) => {
  // Determine currency from parameter, first product, or default to DKK
  const currency = basket?.currency ?? "";
  // Map products to GA4 format
  const items = basket?.lines?.map((product) => {
    const selectItemData = getSelectItemData(product.productId, product.productId);

    return productListItemToGAItem(product, {
      listId: selectItemData?.item_list_id,
      listName: selectItemData?.item_list_name,
      index: selectItemData?.index,
    });
  });


  sendGTMEvent({
    event: 'add_shipping_info',
    ecommerce: {
      shipping_tier: option.priceDescription,
      currency: currency,
      value: option.price,
      items: items || [],
    },
  });
};
